import { render, staticRenderFns } from "./PartnersCenter.vue?vue&type=template&id=2e0208e6&"
import script from "./PartnersCenter.vue?vue&type=script&lang=js&"
export * from "./PartnersCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports